import {
  Component,
  Input,
  OnInit,
  OnDestroy,
  NgZone,
  ViewChild,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import {
  FormBuilder,
  Validators,
  FormControl,
  FormsModule,
  ReactiveFormsModule,
  FormGroup,
} from '@angular/forms';
import { AuthenticationService } from '../../../services/auth/authentication.service';
import { ActivatedRoute, Router, NavigationStart } from '@angular/router';
import { environment } from '../../../../environments/environment';
import { CommonService } from 'src/app/services/api/common.service';
import { NgxUiLoaderService } from 'ngx-ui-loader'; // Import NgxUiLoaderService
import { MixpanelService } from 'src/app/mixpanel.service';
// declare var myExternalJs: any;
import { SharedService } from 'src/app/services/api/message.service';
import { CommonAnnouncementComponent } from 'src/app/pages/common/common-announcement/common-announcement.component';
import { Subscription } from 'rxjs';
import { DirectivesModule } from 'src/app/directives.module';
import { ToastrService } from 'ngx-toastr';
import { mySchoolsService } from 'src/app/services/api/consumer/myschools.service';
import { BsModalService, BsModalRef, ModalOptions } from 'ngx-bootstrap/modal';
import { ChangeDetectorRef } from '@angular/core';
import { Renderer2 } from '@angular/core';
import { PaginationComponent } from 'ngx-bootstrap/pagination';
import { PageChangedEvent } from 'ngx-bootstrap/pagination/public_api';
import { ArticleComponent } from '../../producer/article/article.component';
import { SchoolData } from 'src/app/models/schoolUser';

@Component({
  selector: 'app-schools',
  standalone: true,
  imports: [
    DirectivesModule,
    FormsModule,
    ReactiveFormsModule,
    CommonAnnouncementComponent,
    CommonModule,
    PaginationComponent,
    ArticleComponent
  ],
  templateUrl: './schools.component.html',
  styleUrls: ['./schools.component.scss'],
})
export class SchoolsComponent {
  @ViewChild('deregisterModal') deregisterModalTemplate: any;
  @ViewChild('setPreferenceModalTemplate') setPreferenceModalTemplate: any;
  private isProgrammaticSwitchChange = false;
  schoolCount: any;
  trackBySchoolId(index: number, item: any): any {
    return item.school.id;
  }
  checkedProp: string = '';
  selectAllCheck: boolean = false;
  consumerDetails: Array<any> = [];
  hideButton: boolean = true;
  currentPage: number = 1;
  totalCount: number = 0;
  page: number = 1;

  preferenceForm!: FormGroup;
  selectedSchool: any;
  schoolProps!: SchoolData;

  yearLevels = [
    { label: 'Prep/Foundation', value: '0' },
    { label: 'Year 1', value: '1' },
    { label: 'Year 2', value: '2' },
    { label: 'Year 3', value: '3' },
    { label: 'Year 4', value: '4' },
    { label: 'Year 5', value: '5' },
    { label: 'Year 6', value: '6' },
    { label: 'Year 7', value: '7' },
    { label: 'Year 8', value: '8' },
    { label: 'Year 9', value: '9' },
    { label: 'Year 10', value: '10' },
    { label: 'Year 11', value: '11' },
    { label: 'Year 12', value: '12' },
    { label: 'SEP', value: 'SEP' },
    { label: 'SSEP', value: 'SSEP' },
    { label: 'ECDP', value: 'ECDP' },
  ];


  constructor(
    private fb: FormBuilder,
    private route: ActivatedRoute,
    private ngxService: NgxUiLoaderService,
    private toastr: ToastrService,
    private mySchoolsService: mySchoolsService,
    private zone: NgZone,
    private modalService: BsModalService,
    private _router: Router,
    public bsModalRef: BsModalRef,
    private cdr: ChangeDetectorRef,
    private renderer: Renderer2
  ) {
    // Remove selectedTeachers from localStorage on any route change
    this._router.events.subscribe((event) => {
      if (event instanceof NavigationStart) {
        localStorage.removeItem('selectedTeachers');
      }
    });
  }
  switchRenderKey = 0;
  restoreSwitchState() {
    let updated = false;
    this.isProgrammaticSwitchChange = true;
    if (this.filterType === 'appear_action') {
      this.mySchoolsData = this.mySchoolsData.map((s: any) => {
        if (s.school.id === this.selectedSchoolId) {
          updated = true;
          return { ...s, is_available: this.previousAvailableValue };
        }
        return s;
      });
      setTimeout(() => {
        try {
          const checkbox = this.renderer.selectRootElement(
            '#' + this.checkedProp,
            true
          );
          this.renderer.setProperty(
            checkbox,
            'checked',
            this.previousAvailableValue
          );
          const event = new Event('change', { bubbles: true });
          checkbox.dispatchEvent(event);
        } catch (e) { }
        this.isProgrammaticSwitchChange = false;
      }, 0);
    }
    if (this.filterType === 'preconfirm_action') {
      this.mySchoolsData = this.mySchoolsData.map((s: any) => {
        if (s.school.id === this.selectedSchoolId) {
          updated = true;
          return { ...s, enable_preconfirmed: this.previousPreconfirmValue };
        }
        return s;
      });
      setTimeout(() => {
        try {
          const checkbox = this.renderer.selectRootElement(
            '#' + this.checkedProp,
            true
          );
          this.renderer.setProperty(
            checkbox,
            'checked',
            this.previousPreconfirmValue
          );
          const event = new Event('change', { bubbles: true });
          checkbox.dispatchEvent(event);
        } catch (e) { }
        this.isProgrammaticSwitchChange = false;
      }, 0);
    }
    this.switchRenderKey++;
    this.cdr.detectChanges();
  }
  private previousAvailableValue: boolean | null = false;
  private previousPreconfirmValue: boolean | null = false;
  @ViewChild('actionTeacherModalTemplate') actionTeacherModalTemplate: any;
  filterType: any;
  get selectedSchoolName(): string {
    if (!this.mySchoolsData || !this.selectedSchoolId) return '';
    const school = this.mySchoolsData.find(
      (s: any) => s.school.id === this.selectedSchoolId
    );
    return school ? school.school.title : '';
  }

  get confirmationText(): string[] {
    switch (this.filterType) {
      case 'appear_action':
        if (this.selectedAvailableValue === true)
          return [
            `Are you sure you want to appear available to ${this.selectedSchoolName}?`,
          ];
        else
          return [
            `Are you sure you want to appear unavailable to ${this.selectedSchoolName}?`,
          ];
      case 'preconfirm_action':
        if (this.selectedAvailableValue === true)
          return [
            `${this.selectedSchoolName} will now be able to book you using pre-confirmed bookings.`,
          ];
        else
          return [
            `${this.selectedSchoolName} will not be able to book you using pre-confirmed bookings.`,
          ];
      case 'deregister':
        return [
          `Are you sure you want to deregister from ${this.selectedSchoolName}?`,
          'The School will receive an email confirmation of this action, and only the school will be able to re-register you.',
        ];
      case 'deregister_bulk':
        return [
          `Are you sure you want to deregister from selected schools?`,
          'The School will receive an email confirmation of this action, and only the school will be able to re-register you.',
        ];
      default:
        return ['Are you sure you want to proceed?'];
    }
  }

  get confirmationHeading(): string {
    switch (this.filterType) {
      case 'appear_action':
        return this.selectedAvailableValue === true
          ? 'Appear available'
          : 'Appear unavailable';
      case 'preconfirm_action':
        return this.selectedAvailableValue === true
          ? 'Are you sure you want to enable pre-confirmed bookings?'
          : 'Are you sure you want to disable pre-confirmed bookings?';
      case 'deregister':
        return 'Deregister School';
      case 'deregister_bulk':
        return 'Deregister Schools';
      default:
        return 'Confirmation';
    }
  }

  onAvailabilitySwitchChange(id: any, eventOrEmpty: any, filterType: any) {
    if (this.isProgrammaticSwitchChange) {
      return;
    }
    // Only handle appear_action and preconfirm_action here
    if (filterType === 'appear_action') {
      const school = this.mySchoolsData.find((s: any) => s.school.id === id);
      this.previousAvailableValue = school ? school.is_available : false;
      this.checkedProp = 'availability-switch-' + id;
      this.selectedSchoolId = id;
      this.filterType = filterType;
      const checked =
        eventOrEmpty && eventOrEmpty.target
          ? (eventOrEmpty.target as HTMLInputElement).checked
          : false;
      this.selectedAvailableValue = checked;
      this.bsModalRef = this.modalService.show(
        this.actionTeacherModalTemplate,
        { class: 'modal-md', backdrop: 'static' }
      );
    }
    if (filterType === 'preconfirm_action') {
      const school = this.mySchoolsData.find((s: any) => s.school.id === id);
      this.previousPreconfirmValue = school
        ? school.enable_preconfirmed
        : false;
      this.checkedProp = 'pre-confirmed-switch-' + id;
      this.selectedSchoolId = id;
      this.filterType = filterType;
      const checked =
        eventOrEmpty && eventOrEmpty.target
          ? (eventOrEmpty.target as HTMLInputElement).checked
          : false;
      this.selectedAvailableValue = checked;
      this.bsModalRef = this.modalService.show(
        this.actionTeacherModalTemplate,
        { class: 'modal-md', backdrop: 'static' }
      );
    }
  }
  mySchoolsData: any;
  // declineTeacherModal: any; // Not needed with BsModalService
  selectedSchoolId: any;
  selectedAvailableValue: boolean | null = false;

  ngOnInit(): void {
    this.ngxService.start();
    const data = {
      page: this.page,
    };
    this.schoolProps = JSON.parse(localStorage.getItem('userData') || '{}');
    this.mySchoolsService.mySchoolsAPI(data).subscribe({
      next: (res: any) => {
        if (res.status) {
          this.mySchoolsData = res.data.school_list;
          this.schoolCount = res.data.school_count;
          // Restore selection from local storage after data is loaded
          localStorage.removeItem('selectedTeachers');
          // this.mySchoolsData.forEach((x: any) => {
          //   x.isChecked = selectedIds.includes(x.school.id);
          // });
          // this.consumerDetails = this.mySchoolsData.filter(
          //   (x: any) => x.isChecked
          // );
          // this.selectAllCheck =
          //   this.mySchoolsData.length > 0 &&
          //   this.mySchoolsData.every((x: any) => x.isChecked);
          this.totalCount = parseInt(res.data.page_count) * 10;
          this.ngxService.stop();
        } else {
          this.toastr.error(res.message);
          this.ngxService.stop();
        }
      },
      error: (err: any) => {
        this.ngxService.stop();
        this.toastr.error(err.error.message);
        console.log(err);
      },
    });

    this.preferenceForm = this.fb.group({
      preferred_year_level: [[], Validators.required],
      work_type: [[], Validators.required],
      myteacher_id: [],
    });
  }
  getSchoolList(page: number): void {
    this.page = page;
    this.ngxService.start();
    const data = {
      page: this.page,
    };
    this.mySchoolsService.mySchoolsAPI(data).subscribe({
      next: (res: any) => {
        if (res.status) {
          this.mySchoolsData = res.data.school_list;
          this.schoolCount = res.data.school_count;
          // Restore selection from local storage after data is loaded
          const selectedIds: any[] = JSON.parse(
            localStorage.getItem('selectedTeachers') || '[]'
          );
          this.mySchoolsData.forEach((x: any) => {
            x.isChecked = selectedIds.includes(x.school.id);
          });
          this.consumerDetails = this.mySchoolsData.filter(
            (x: any) => x.isChecked
          );
          this.selectAllCheck =
            this.mySchoolsData.length > 0 &&
            this.mySchoolsData.every((x: any) => x.isChecked);
          this.totalCount = parseInt(res.data.page_count) * 10;
          this.ngxService.stop();
        } else {
          this.toastr.error(res.message);
          this.ngxService.stop();
        }
      },
      error: (err: any) => {
        this.ngxService.stop();
        this.toastr.error(err.error.message);
        console.log(err);
      },
    });
  }
  // confirmAppearAvailable not needed, handled by onAvailabilitySwitchChange

  appearAvailable(filterType: any) {
    this.ngxService.start();
    if (filterType === 'deregister_bulk') {
      const data = {
        school_id: this.selectedSchoolId.toString(),
        filterType: 'deregister',
        status:
          this.filterType === 'deregister_bulk'
            ? ''
            : this.selectedAvailableValue
              ? 1
              : 0,
      };
      this.mySchoolsService.appearAvailableAPI(data).subscribe({
        next: (res: any) => {
          if (res.status) {
            // Remove from localStorage as before
            localStorage.removeItem('selectedTeachers');
            this.hideButton = true;
            this.selectAllCheck = false;
            this.consumerDetails = [];
            // // Remove the deregistered school from mySchoolsData
            // if (Array.isArray(this.selectedSchoolId)) {
            //   // Bulk deregister: remove all selected IDs
            //   this.selectedSchoolId.forEach((id: any) => {
            //     const idx = this.mySchoolsData.findIndex((x: any) => x.school.id === id);
            //     if (idx > -1) this.mySchoolsData.splice(idx, 1);
            //   });
            // } else {
            //   // Single deregister
            //   const idx = this.mySchoolsData.findIndex((x: any) => x.school.id === this.selectedSchoolId);
            //   if (idx > -1) this.mySchoolsData.splice(idx, 1);
            // }

            // If after removal, mySchoolsData is empty, fetch previous page (unless already on page 1)
            if (this.mySchoolsData.length === 0) {
              const newPage = this.page > 1 ? this.page - 1 : 1;
              this.getSchoolList(newPage);
              this.page = newPage;
            } else {
              this.getSchoolList(this.page);
            }

            this.bsModalRef.hide();
            this.toastr.success(res.message);
            this.ngxService.stop();
          } else {
            this.toastr.error(res.message);
            this.ngxService.stop();
          }
        },
        error: (err: any) => {
          this.ngxService.stop();
          this.toastr.error(err.error.message);
          console.log(err);
        },
      });
    } else {
      const data = {
        school_id: this.selectedSchoolId.toString(),
        filterType: this.filterType,
        status:
          this.filterType === 'deregister'
            ? ''
            : this.selectedAvailableValue
              ? 1
              : 0,
      };
      this.mySchoolsService.appearAvailableAPI(data).subscribe({
        next: (res: any) => {
          if (res.status) {
            // Remove from localStorage as before
            this.hideButton = true;
            this.selectAllCheck = false;
            this.consumerDetails = [];
            localStorage.removeItem('selectedTeachers');
            // // Remove the deregistered school from mySchoolsData
            // if (Array.isArray(this.selectedSchoolId)) {
            //   // Bulk deregister: remove all selected IDs
            //   this.selectedSchoolId.forEach((id: any) => {
            //     const idx = this.mySchoolsData.findIndex((x: any) => x.school.id === id);
            //     if (idx > -1) this.mySchoolsData.splice(idx, 1);
            //   });
            // } else {
            //   // Single deregister
            //   const idx = this.mySchoolsData.findIndex((x: any) => x.school.id === this.selectedSchoolId);
            //   if (idx > -1) this.mySchoolsData.splice(idx, 1);
            // }

            // If after removal, mySchoolsData is empty, fetch previous page (unless already on page 1)
            if (this.mySchoolsData.length === 0) {
              const newPage = this.page > 1 ? this.page - 1 : 1;
              this.getSchoolList(newPage);
              this.page = newPage;
            } else {
              this.getSchoolList(this.page);
            }

            this.bsModalRef.hide();
            this.toastr.success(res.message);
            this.ngxService.stop();
          } else {
            this.toastr.error(res.message);
            this.ngxService.stop();
          }
        },
        error: (err: any) => {
          this.ngxService.stop();
          this.toastr.error(err.error.message);
          console.log(err);
        },
      });
    }
  }

  onDeregisterClick(id: any) {
    if (id === '') {
      this.filterType = 'deregister_bulk';
      this.bsModalRef = this.modalService.show(this.deregisterModalTemplate, {
        class: 'modal-md',
        backdrop: 'static',
      });
      const selectedIds: any[] = JSON.parse(
        localStorage.getItem('selectedTeachers') || '[]'
      );
      this.selectedSchoolId = selectedIds;
    } else {
      this.selectedSchoolId = id;
      this.filterType = 'deregister';
      this.selectedAvailableValue = null;

      this.bsModalRef = this.modalService.show(this.deregisterModalTemplate, {
        class: 'modal-md',
        backdrop: 'static',
      });
    }
  }

  setPreferenceModal(data: any) {
    console.log('Data received for preferences:', data);
    this.selectedSchool = data;
    this.bsModalRef = this.modalService.show(this.setPreferenceModalTemplate, {
      class: 'modal-md',
      backdrop: 'static',
    });
    this.prefillForm(data);
    this.preferenceForm.patchValue({
      myteacher_id: data.id,
    });
    console.log('Prefilled form data:', this.preferenceForm.value);

  }

  prefillForm(data: any) {
    if (!data) return;

    const preferred = data.preferred_year_level?.selected_preferred_year_level || [];
    const workType = data.work_type?.selected_work_type || [];

    this.preferenceForm.patchValue({
      preferred_year_level: preferred,
      work_type: workType,
    });
  }

  selectAll(type: any, event: any) {
    var checked = event.target.checked;
    let selectedIds: any[] = JSON.parse(
      localStorage.getItem('selectedTeachers') || '[]'
    );
    if (type == 'All') {
      this.consumerDetails = [];
      this.mySchoolsData.forEach((x: any) => {
        if (checked) {
          x.isChecked = true;
          this.consumerDetails.push(x);
          if (!selectedIds.includes(x.school.id)) {
            selectedIds.push(x.school.id);
          }
          this.hideButton = false;
        } else {
          this.hideButton = true;
          x.isChecked = false;
        }
      });
      if (!checked) {
        // Remove all current page ids from local storage
        const currentPageIds = this.mySchoolsData.map((x: any) => x.school.id);
        selectedIds = selectedIds.filter(
          (id: any) => !currentPageIds.includes(id)
        );
      }
      localStorage.setItem('selectedTeachers', JSON.stringify(selectedIds));
    } else {
      if (checked) {
        type.isChecked = true;
        this.consumerDetails.push(type);
        if (!selectedIds.includes(type.school.id)) {
          selectedIds.push(type.school.id);
        }
        this.hideButton = false;
      } else {
        type.isChecked = false;
        this.consumerDetails = this.consumerDetails.filter((x) => x != type);
        selectedIds = selectedIds.filter((id: any) => id !== type.school.id);
      }
      localStorage.setItem('selectedTeachers', JSON.stringify(selectedIds));
    }
    this.selectAllCheck =
      this.mySchoolsData.length > 0 &&
      this.mySchoolsData.every((x: any) => x.isChecked);
    if (this.consumerDetails.length > 0) {
      this.hideButton = false;
    } else {
      this.hideButton = true;
    }
  }
  getSelectedTeachersCount(): number {
    const selectedIds: any[] = JSON.parse(
      localStorage.getItem('selectedTeachers') || '[]'
    );
    return selectedIds.length;
  }
  clearSelectedTeachers() {
    localStorage.removeItem('selectedTeachers');
    this.consumerDetails = [];
    this.mySchoolsData.forEach((x: any) => (x.isChecked = false));
    this.selectAllCheck = false;
    this.hideButton = true;
  }
  pageChanged(event: PageChangedEvent): void {
    this.selectAllCheck = false;
    // Restore selection from local storage
    const selectedIds: any[] = JSON.parse(
      localStorage.getItem('selectedTeachers') || '[]'
    );
    if (this.mySchoolsData && Array.isArray(this.mySchoolsData)) {
      this.mySchoolsData.forEach((x: any) => {
        console.log(x);
        x.isChecked = selectedIds.includes(x.school.id);
      });
      // Update consumerDetails to match selected on this page
      this.consumerDetails = this.mySchoolsData.filter((x: any) => x.isChecked);
      // If all on page are selected, set selectAllCheck true
      this.selectAllCheck =
        this.mySchoolsData.length > 0 &&
        this.mySchoolsData.every((x: any) => x.isChecked);
    }
    this.page = event.page;
    this.getSchoolList(this.page);
    window.scrollTo(0, 0); // Scroll to top on page change
  }
  findNewSchools() {
    this._router.navigate(['teacher/find-new-schools']);
  }


  saveSchoolPreferences() {
    if (this.preferenceForm.invalid) {
      this.preferenceForm.markAllAsTouched();
      return;
    }
    this.ngxService.start();
    const payload = this.preferenceForm.value;
    // return;
    // Output: { preferred_year_level: ["0", "1", "2"], work_type: ["C", "T"] }


    // Here you can send the selectedPreferences to your backend API
    // For example:
    this.mySchoolsService.setPreferencesAPI(payload).subscribe({
      next: (res: any) => {
        if (res.status) {
          this.ngxService.stop();
          this.toastr.success(res.message || 'Preferences saved successfully');
          this.bsModalRef.hide();
          console.log('Preferences saved:', this.page);
          this.getSchoolList(this.page);
        } else {
          this.toastr.error(res.message);
          this.ngxService.stop();
        }
      },
      error: (err: any) => {
        this.ngxService.stop();
        this.toastr.error(err.error.message);
        console.log(err);
      },
    });
  }

  onYearLevelChange(event: any) {
    const selected = [...this.preferenceForm.value.preferred_year_level];
    if (event.target.checked) {
      selected.push(event.target.value);
    } else {
      const index = selected.indexOf(event.target.value);
      if (index > -1) selected.splice(index, 1);
    }
    this.preferenceForm.patchValue({ preferred_year_level: selected });
    this.preferenceForm.get('preferred_year_level')?.updateValueAndValidity();
  }

  onWorkTypeChange(event: any) {
    const selected = [...this.preferenceForm.value.work_type];
    if (event.target.checked) {
      selected.push(event.target.value);
    } else {
      const index = selected.indexOf(event.target.value);
      if (index > -1) selected.splice(index, 1);
    }
    this.preferenceForm.patchValue({ work_type: selected });
    this.preferenceForm.get('work_type')?.updateValueAndValidity();
  }
  handlePageData(data: any) {
    // Store the page data for later use, e.g. pagination or display
    this.pageData = data;
    // Optionally, update the UI or trigger other logic if needed
    // Example: this.obsArray.next(data.consumer_list || []);
  }
  pageData: any;
  openPublicProfile(slug: string) {
    window.open('public-profile/' + slug + '?from=my-school', '_blank');
  }
}
